import React, { useEffect, useState } from 'react';
import { ProductLine } from '../../components/AmazonInventory/ProductLine';
import { FilterApprovedButton } from '../../components/AmazonInventory/FilterApprovedButton.js';
import { SelectProductButtons } from '../../components/AmazonInventory/SelectProductButtons';
import { ResetButton } from '../../components/AmazonInventory/ResetButton';
import { Col } from 'react-bootstrap';
import { TableToRender } from './TableToRender';


export const AmazonInventoryScreen = (props) => {
  const [displayProducts, setDisplayProducts] = useState(props.filteredInventory); //acts as another filter for filteredInventory - which products get displayed from that
  const [filters, setFilters] = useState({});
  const [searchText, setSearchText] = useState('');


  return (
    <div>
      <div className='d-flex align-items-center'>
        <Col xs={4}>
        </Col>
        <Col xs={2}>
         
        </Col>
        <Col xs={2}>
          
        </Col>
      </div>
      {/* <table>
        <thead>
          <tr>
            <th>Select</th>
            <th>ID</th>
            <th>ASIN</th>
            <th>Name</th>
            <th>Cost Price</th>
            <th>Weight</th>
            <th>Packaging</th>
            <th>Base Lock</th>
            <th>Regional Lock</th>
            <th>Blended Min Margin</th>
            <th>Blended Max Margin</th>
            <th>Edit</th>
            <th>Approved</th>
          </tr>
        </thead>
        <tbody>
          {Object.values(props.filteredInventory).map((product) => {
            if (displayProducts.indexOf(product.id) === -1) {
              return;
            }
            return (
              <ProductLine
                product={product}
                key={product.id}
                displayProducts={displayProducts}
                selectedProductLines={props.selectedProductLines}
                selectedProductObj={props.selectedProductObj}
                updateSelectedProductLines={props.updateSelectedProductLines}
                setSelectedProductObj={(product) => {
                  props.setSelectedRows(product);
                }}
                updateBaseProductAttribute={(e, index) => {
                  props.updateBaseProductAttribute(e, index);
                }}
                updateRegionalProductAttribute={(e, region, index) => {
                  props.updateRegionalProductAttribute(e, region, index);
                }}
                recalculateFromBasePrices={props.recalculateFromBasePrices}
                selectedRegions={props.selectedRegions}
                setSelectedRegions={props.setSelectedRegions}
                updateRegionArr={(e) => {
                  props.updateRegionArr(e);
                }}
                amazonInventory={props.amazonInventory}
                setAmazonInventory={props.setAmazonInventory}
                updateStateOnHideModal={(e) => {
                  props.updateStateOnHideModal(e);
                }}
              />
            );
          })}
        </tbody>
      </table> */}
      <TableToRender
        products={props.amazonInventory}
        setSelectedRows={(product) => {
          props.setSelectedRows(product);
        }}
        selectedRows={props.selectedRows}
        selectedRegions={props.selectedRegions}
        setSelectedRegions={props.setSelectedRegions}
        updateBaseProductAttribute={(e, index) => {
          props.updateBaseProductAttribute(e, index);
        }}
        updateRegionalProductAttribute={(e, region, index, value) => {
          props.updateRegionalProductAttribute(e, region, index, value);
        }}
        updateStateOnHideModal={(e) => {
          props.updateStateOnHideModal(e);
        }}
        recalculateFromBasePrices={props.recalculateFromBasePrices}
        updateRegionArr={props.updateRegionArr}
      />
    </div>
  );
};
